import React from 'react'
import { useTranslation } from 'react-i18next'
import './TableEmptyState.css'

type TableLoadingStateProps = {
  /** Smaller padding for nested / accordion tables */
  compact?: boolean
  label?: string
}

/** Branded loading placeholder for list tables (avoids empty-state flash). */
export default function TableLoadingState({
  compact = false,
  label,
}: TableLoadingStateProps) {
  const { t } = useTranslation()
  return (
    <div
      className={`incyia-empty incyia-empty--loading${compact ? ' is-compact' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="incyia-empty-spinner" aria-hidden />
      <p className="incyia-empty-title">
        {label ??
          t('listPages.loading', {
            defaultValue: 'Loading…',
          })}
      </p>
      <p className="incyia-empty-hint">
        {t('listPages.loadingHint', {
          defaultValue: 'Fetching records, this will only take a moment.',
        })}
      </p>
    </div>
  )
}
